module.exports = __webpack_public_path__ + "logo-tennisekeskus-klubi.svg?28b261a6ff6c96471c9510c597376d35";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-tennisekeskus-klubi.svg
// module id = 276
// module chunks = 0